import React from "react"
import { useTranslation } from "react-i18next"

import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"

export interface DeleteProjectChildrenOverlayViewModel {
  onDelete: () => void
  onCancel: () => void
}

export const DeleteProjectChildrenOverlayView = React.memo(
  ({ onDelete, onCancel }: DeleteProjectChildrenOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <ConfirmationOverlay.Root id="delete-project-children-overlay" isDanger>
        <ConfirmationOverlay.Header>
          <ConfirmationOverlay.Title>
            {t("ProjectChild.Actions.Delete")}
          </ConfirmationOverlay.Title>
        </ConfirmationOverlay.Header>
        <ConfirmationOverlay.Message>
          {t("ProjectChild.DeleteConfirmation")}
        </ConfirmationOverlay.Message>
        <ConfirmationOverlay.Actions>
          <ConfirmationOverlay.Cancel onClick={onCancel} />
          <ConfirmationOverlay.Submit onClick={onDelete}>
            {t("General.Delete")}
          </ConfirmationOverlay.Submit>
        </ConfirmationOverlay.Actions>
      </ConfirmationOverlay.Root>
    )
  }
)
